import React, { useState, useEffect } from 'react';

function Schnitzeljagd() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedTermin, setSelectedTermin] = useState(null);
  const [bookingForm, setBookingForm] = useState({
    family_name: '',
    email: '',
    phone: '',
    adults: 1,
    children: 0,
    children_ages: '',
    message: ''
  });
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchEvents();
  }, []);

  const fetchEvents = () => {
    setLoading(true);
    fetch('/api/public/schnitzeljagd')
      .then(res => res.json())
      .then(data => {
        setEvents(data.data || []);
        setLoading(false);
      })
      .catch(err => {
        console.error('Fehler:', err);
        setLoading(false);
      });
  };

  const handleBooking = (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError(null);

    fetch(`/api/public/schnitzeljagd/${selectedTermin.id}/book`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(bookingForm)
    })
      .then(res => res.json())
      .then(data => {
        setSubmitting(false);
        if (data.message === 'success') {
          setSuccess(data.data);
          setSelectedTermin(null);
          setBookingForm({
            family_name: '',
            email: '',
            phone: '',
            adults: 1,
            children: 0,
            children_ages: '',
            message: ''
          });
          fetchEvents();
        } else {
          setError(data.error || 'Fehler bei der Anmeldung');
        }
      })
      .catch(err => {
        setSubmitting(false);
        setError('Verbindungsfehler');
      });
  };

  const formatDate = (dateStr) => {
    return new Date(dateStr).toLocaleDateString('de-DE', {
      weekday: 'long',
      day: '2-digit',
      month: 'long',
      year: 'numeric'
    });
  };

  // Success view
  if (success) {
    return (
      <div className="container py-4">
        <div className="card border-success">
          <div className="card-body text-center py-5">
            <div className="mb-4">
              <span style={{ fontSize: '64px' }}>🐰</span>
            </div>
            <h2 className="text-success mb-3">Anmeldung erfolgreich!</h2>
            <p className="lead mb-4">
              Vielen Dank, Familie {success.family_name}!<br />
              Eure Anmeldung zur Oster-Schnitzeljagd wurde bestaetigt.
            </p>
            <div className="bg-light rounded p-3 mb-4">
              <strong>{success.event_title}</strong><br />
              {formatDate(success.termin_date)}<br />
              {success.termin_time} Uhr
            </div>
            <p className="text-muted mb-4">
              Eine Bestaetigung wird an <strong>{success.email}</strong> gesendet.
            </p>
            <button
              className="btn btn-outline-primary"
              onClick={() => setSuccess(null)}
            >
              Zurueck zur Uebersicht
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container py-4">
      <div className="text-center mb-4">
        <span style={{ fontSize: '48px' }}>🐰 🥚 🌷</span>
        <h1 className="mt-3">Oster-Schnitzeljagd Schorndorf</h1>
        <p className="lead text-muted">
          Hybride Familien-Aktion durch die Altstadt
        </p>
      </div>

      {loading ? (
        <div className="text-center py-5">
          <div className="spinner-border text-primary"></div>
        </div>
      ) : selectedTermin ? (
        /* Booking Form */
        <div className="row justify-content-center">
          <div className="col-md-8">
            <div className="card">
              <div className="card-header bg-primary text-white">
                <h5 className="mb-0">Anmeldung zur Schnitzeljagd</h5>
              </div>
              <div className="card-body">
                <div className="alert alert-light border mb-4">
                  <h5>{selectedTermin.event_title}</h5>
                  <strong>{formatDate(selectedTermin.date)}</strong><br />
                  Start jederzeit zwischen {selectedTermin.start_time} - {selectedTermin.end_time} Uhr<br />
                  <span className="text-muted">Start: Futurhinos for Kids, Gottlieb-Daimler-Str. 36</span>
                </div>

                {error && <div className="alert alert-danger">{error}</div>}

                <form onSubmit={handleBooking}>
                  <div className="mb-3">
                    <label className="form-label">Familienname *</label>
                    <input
                      type="text"
                      className="form-control"
                      value={bookingForm.family_name}
                      onChange={e => setBookingForm({ ...bookingForm, family_name: e.target.value })}
                      required
                      placeholder="z.B. Familie Mueller"
                    />
                  </div>

                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label">E-Mail *</label>
                      <input
                        type="email"
                        className="form-control"
                        value={bookingForm.email}
                        onChange={e => setBookingForm({ ...bookingForm, email: e.target.value })}
                        required
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Telefon</label>
                      <input
                        type="tel"
                        className="form-control"
                        value={bookingForm.phone}
                        onChange={e => setBookingForm({ ...bookingForm, phone: e.target.value })}
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Anzahl Erwachsene</label>
                      <input
                        type="number"
                        className="form-control"
                        value={bookingForm.adults}
                        onChange={e => setBookingForm({ ...bookingForm, adults: parseInt(e.target.value) })}
                        min="1"
                        max="4"
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Anzahl Kinder</label>
                      <input
                        type="number"
                        className="form-control"
                        value={bookingForm.children}
                        onChange={e => setBookingForm({ ...bookingForm, children: parseInt(e.target.value) || 0 })}
                        min="0"
                        max="10"
                      />
                    </div>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Alter der Kinder</label>
                    <input
                      type="text"
                      className="form-control"
                      value={bookingForm.children_ages}
                      onChange={e => setBookingForm({ ...bookingForm, children_ages: e.target.value })}
                      placeholder="z.B. 6 und 9 Jahre"
                    />
                    <small className="text-muted">Empfohlen fuer Kinder von 5-12 Jahren</small>
                  </div>

                  <div className="mb-4">
                    <label className="form-label">Nachricht / Fragen</label>
                    <textarea
                      className="form-control"
                      rows="2"
                      value={bookingForm.message}
                      onChange={e => setBookingForm({ ...bookingForm, message: e.target.value })}
                    />
                  </div>

                  <div className="d-flex gap-2">
                    <button
                      type="submit"
                      className="btn btn-primary btn-lg flex-grow-1"
                      disabled={submitting}
                    >
                      {submitting ? 'Wird angemeldet...' : 'Jetzt Platz sichern'}
                    </button>
                    <button
                      type="button"
                      className="btn btn-outline-secondary btn-lg"
                      onClick={() => setSelectedTermin(null)}
                      disabled={submitting}
                    >
                      Zurueck
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      ) : events.length === 0 ? (
        <div className="text-center py-5">
          <div className="card">
            <div className="card-body py-5">
              <h4>Aktuell keine Schnitzeljagd geplant</h4>
              <p className="text-muted mb-4">
                Schau bald wieder vorbei!
              </p>
            </div>
          </div>
        </div>
      ) : (
        /* Event List */
        <div>
          {events.map(event => (
            <div key={event.id} className="card mb-4">
              <div className="card-header bg-warning">
                <h4 className="mb-0">{event.title}</h4>
              </div>
              <div className="card-body">
                {event.description && (
                  <p className="mb-3">{event.description}</p>
                )}

                <div className="row mb-3">
                  <div className="col-md-4">
                    <strong>Zeitraum:</strong><br />
                    {new Date(event.start_date).toLocaleDateString('de-DE')} - {new Date(event.end_date).toLocaleDateString('de-DE')}
                  </div>
                  <div className="col-md-4">
                    <strong>Startpunkt:</strong><br />
                    {event.location || 'Futurhinos for Kids'}
                  </div>
                  <div className="col-md-4">
                    <strong>Preis:</strong><br />
                    {event.price > 0 ? `${parseFloat(event.price).toFixed(2)} EUR pro Familie` : 'Kostenlos'}
                  </div>
                </div>

                <h5 className="mt-4 mb-3">Verfuegbare Termine:</h5>

                {event.termine && event.termine.length > 0 ? (
                  <div className="row">
                    {event.termine.map(termin => {
                      const spotsLeft = termin.max_participants - (termin.booked_count || 0);
                      const isFull = spotsLeft <= 0;

                      return (
                        <div key={termin.id} className="col-md-4 mb-3">
                          <div className={`card h-100 ${isFull ? 'bg-light' : 'border-primary'}`}>
                            <div className="card-body text-center">
                              <h5>{formatDate(termin.date)}</h5>
                              <p className="mb-2">Start: {termin.start_time} - {termin.end_time} Uhr</p>
                              <p className={`badge ${isFull ? 'bg-danger' : 'bg-success'} mb-3`}>
                                {isFull ? 'Ausgebucht' : `Noch ${spotsLeft} Plaetze frei`}
                              </p>
                              <br />
                              <button
                                className="btn btn-primary"
                                onClick={() => setSelectedTermin({ ...termin, event_title: event.title })}
                                disabled={isFull}
                              >
                                {isFull ? 'Ausgebucht' : 'Anmelden'}
                              </button>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <p className="text-muted">Termine werden bald bekannt gegeben.</p>
                )}
              </div>
            </div>
          ))}

          <div className="card bg-light mt-4">
            <div className="card-body">
              <h5>So funktioniert die Schnitzeljagd:</h5>
              <ol className="mb-0">
                <li>Meldet euch fuer einen Termin an</li>
                <li>Kommt zum Startpunkt (Futurhinos for Kids) und holt euren QR-Code + Osternest ab</li>
                <li>Loest die Raetsel an 10 Stationen in der Altstadt</li>
                <li>Sammelt bei den Partner-Geschaeften kleine Oster-Ueberraschungen</li>
                <li>Beendet die Jagd am Ziel (Ama Deli) mit einer letzten Belohnung!</li>
              </ol>
              <p className="mt-3 mb-0 text-muted">
                <strong>Dauer:</strong> ca. 60-90 Minuten | <strong>Strecke:</strong> ca. 1,5-2 km | <strong>Empfohlen fuer:</strong> Kinder 5-12 Jahre
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Schnitzeljagd;
